<h2 mat-dialog-title>Kontakt setzen</h2>

<mat-dialog-content class="dialog-content" style="overflow: hidden; max-height: none">
    <p>Es werden {{ data?.tiere?.length || 0 }} ausgewählte Tiere aktualisiert.</p>

    <section class="toggle-area">
        <section class="auswahl-section" *ngIf="isSearchVisible()">
            <kiene-betriebskontakt-auswahl
                [config]="{
                    showLandwirte: true,
                    showHaendler: true,
                    showSchlachthoefe: true,
                    showAll: true,
                    multiSelect: false,
                    compact: true,
                    title: 'Kontakt auswählen',
                    placeholder: 'Kontakt suchen...'
                }"
                [selectedKontakte]="selectedKontakt ? [selectedKontakt] : []"
                (kontaktSelected)="onKontaktSelected($event)"
                (kontakteSelected)="onKontakteSelected($event)"
            >
            </kiene-betriebskontakt-auswahl>
            <p class="hinweis-text">Wenn kein Kontakt ausgewählt ist, wird der bisherige Kontakt entfernt.</p>
        </section>

        <section *ngIf="isSelectedPreviewVisible()" class="selected-card">
            <h4>Ausgewählter Kontakt</h4>
            <div class="selected-summary selected-summary--mobile" (click)="openSearchBlock()">
                <div class="selected-summary__name">
                    {{ selectedKontakt.bezeichnung_final || selectedKontakt.bezeichnung || 'Kontakt ausgewählt' }}
                </div>
                <div class="selected-summary__meta" *ngIf="selectedKontakt.vvvo">VVVO: {{ selectedKontakt.vvvo }}</div>
                <div class="selected-summary__hint">Tippen zum Ändern</div>
            </div>
        </section>

        <section *ngIf="selectedKontakt && !isMobileView" class="selected-card">
            <h4>Ausgewählter Kontakt</h4>
            <div class="selected-card__full">
                <kiene-betriebskontakt-card
                    [kontakt]="selectedKontakt"
                    [config]="{
                        showActions: false,
                        showMenu: false,
                        showFavorit: false,
                        compact: true,
                        showBadge: false,
                        selectedMode: true
                    }"
                >
                </kiene-betriebskontakt-card>
            </div>
        </section>
    </section>
</mat-dialog-content>

<mat-dialog-actions align="end">
    <button mat-button (click)="cancel()" [disabled]="isSaving">Abbrechen</button>
    <button mat-flat-button color="primary" (click)="save()" [disabled]="isSaving">
        <mat-spinner *ngIf="isSaving" diameter="20"></mat-spinner>
        <span *ngIf="!isSaving">Speichern</span>
    </button>
</mat-dialog-actions>
